import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'
import './report.css'
import './executive-report.css'
import './light-report.css'
import './report-polish.css'
import './report-information.css'
import './report-actions.css'
import './report-refine.css'
import './responsive.css'

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>)
